module.exports = __webpack_public_path__ + "img/search_poi_n_b.1c30f35.png";